module.exports = __webpack_public_path__ + "img/interferenciaGps.19702c88.svg";